import RecipeView from '@app/Recipe/View'

export function install(Vue) {
  Vue.component(RecipeView.name, RecipeView)
}

export default { install }
